import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";


import { globalStyles } from "ui/globalStyles";


export interface ReportSummaryProps {
    totalPeople: number,
    totalReservations : number
}

export function ReportSummary({ totalPeople, totalReservations }: ReportSummaryProps): ReactElement {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                border: globalStyles.border,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                mx: 1.25,
                p: 1.25,
            }}
        >
            <Typography
                sx={{
                    fontWeight: "bold",
                    textAlign: "left",
                    width: "33.3%",
                }}
            >
                { t("TOTAL").toLocaleUpperCase() }
            </Typography>
            <Typography
                sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    width: "33.3%",
                }}
            >
                { totalReservations }
            </Typography>
            <Typography
                sx={{
                    fontWeight: "bold",
                    textAlign: "right",
                    width: "33.3%",
                }}
            >
                { totalPeople }
            </Typography>
        </Box>
    );
}